import React, { useEffect, useState, memo } from 'react';
import { Table, TableBody, TableCell, TableRow, TextField } from '@material-ui/core';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';
import { Check, Close, Visibility } from '@material-ui/icons';
import RegularButton from 'components/CustomButtons/Button';
import ModalBase from 'components/Tvendo/Common/ModalBase';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import { wsCreate } from 'services/WService';
import moment from 'moment';

function DuplicatePromotionModal(props) {
  const { model, setOpen } = props;
  const [loading, setLoading] = useState(false);
  const [complete, setComplete] = useState(false);
  const [promotions, setPromotions] = useState([]);
  const [abortController, setAbortController] = useState();
  const [startDate, setStartDate] = useState(moment().format('YYYY-MM-DD'));
  const [endDate, setEndDate] = useState(moment().endOf('month').format('YYYY-MM-DD'));

  function handleCancel() {
    if (abortController !== undefined) {
      abortController.abort();
    }
  }

  async function duplicateAllPromotions() {
    if (startDate === '' || endDate === '') {
      window.alert('Seleccionar fechas de inicio y fin');
      return;
    }

    setLoading(true);
    let controller = new AbortController();
    setAbortController(controller);
    for (let prom of model.promotions) {
      if (controller.signal.aborted) {
        setLoading(false);
        setComplete(true);
        window.alert('Se detuvo el duplicado de promociones');
        return;
      }

      let newPromId = await duplicate(prom);
      setPromotions((promotions) => {
        let newPromotions = [...promotions];
        let index = newPromotions.findIndex((item) => item.id === prom.id);
        if (index > -1) {
          newPromotions[index].newId = newPromId;
        }
        return newPromotions;
      });
    }
    setLoading(false);
    setComplete(true);
    window.alert('Se completo de duplicar la promociones');
  }

  async function duplicate(prom) {
    // ! Test
    // let newPromoIdTest = await new Promise((resolve) => {
    //   setTimeout(() => {
    //     resolve(1);
    //   }, 2000);
    // });
    // return newPromoIdTest;

    let res = await wsCreate('prom/promotion/duplicate', {
      prom_promotion_id: prom.id,
      start_date: startDate,
      end_date: endDate,
    });
    if (res.success) {
      return res.data;
    }
    return null;
  }

  useEffect(() => {
    if (model.promotions === undefined) {
      setPromotions([]);
      setComplete(false);
      return;
    }

    setPromotions(
      model.promotions.map((prom) => ({
        id: prom.id,
        description: prom.description,
        newId: undefined,
      })),
    );
    setComplete(false);
  }, [model.promotions]);

  return (
    <ModalBase
      model={model}
      setOpen={setOpen}
      handleCloseDisabled={loading}
      hideSave
      fullWidth
      maxWidth="lg"
      title={`Duplicar ${promotions.length} promociones`}
    >
      <GridContainer>
        <GridItem xs={12} sm={6} md={3}>
          <TextField
            fullWidth
            label="Fecha inicio"
            type="date"
            required
            disabled={loading}
            value={startDate}
            onChange={(e) => {
              setStartDate(e.target.value);
            }}
            InputLabelProps={{ shrink: true }}
          />
        </GridItem>
        <GridItem xs={12} sm={6} md={3}>
          <TextField
            fullWidth
            label="Fecha fin"
            type="date"
            required
            disabled={loading}
            value={endDate}
            onChange={(e) => {
              setEndDate(e.target.value);
            }}
            InputLabelProps={{ shrink: true }}
          />
        </GridItem>
        <GridItem xs={12} sm={6} md={3} lg={3} xl={2}>
          <RegularButton
            fullWidth
            color="success"
            disabled={loading || complete}
            onClick={duplicateAllPromotions}
          >
            Comenzar
          </RegularButton>
        </GridItem>
        <GridItem xs={12} sm={6} md={3} lg={3} xl={2}>
          <RegularButton fullWidth color="danger" disabled={complete} onClick={handleCancel}>
            Cancelar
          </RegularButton>
        </GridItem>
      </GridContainer>

      <GridContainer>
        <Table>
          <TableBody>
            {promotions.map((prom) => {
              return (
                <TableRow key={prom.id}>
                  <TableCell width={'50%'}>{prom.description}</TableCell>
                  <TableCell width={'10%'}>{prom.id}</TableCell>
                  <TableCell width={'20%'}>
                    {loading && prom.newId === undefined && (
                      <LoadingSpinner
                        styles={{ width: '15px', height: '15px', margin: '0', borderWidth: '5px' }}
                      />
                    )}
                    {/* Reemplaza al loader */}
                    {prom.newId === null && (
                      <>
                        Error
                        <Close color="error" />
                      </>
                    )}
                    {prom.newId !== null && prom.newId !== undefined && (
                      <RegularButton justIcon round simple size="sm">
                        <Check />
                      </RegularButton>
                    )}
                  </TableCell>
                  <TableCell width={'20%'}>
                    {prom.newId}
                    {!!prom.newId && (
                      <RegularButton
                        justIcon
                        round
                        simple
                        color="primary"
                        size="sm"
                        onClick={() => {
                          window.open(
                            `/admin/articulos/operaciones/promociones/${prom.newId}`,
                            '_blank',
                          );
                        }}
                      >
                        <Visibility />
                      </RegularButton>
                    )}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </GridContainer>
    </ModalBase>
  );
}

export default DuplicatePromotionModal;
